/**
 * Created by cl-macmini-34 on 27/04/17.
 */
App.controller('EmailVerifyCtrl', ['$rootScope', '$scope', '$http', '$cookies', '$cookieStore', 'ngDialog', '$timeout', '$localStorage',
    '$sessionStorage', '$state', 'Api', 'toastr', 'authApi', '$stateParams', '$loading', '$location', 'ProfessionalService', 'sessionService',
    function ($rootScope, $scope, $http, $cookies, $cookieStore, ngDialog, $timeout, $localStorage, $sessionStorage,
              $state, Api, toastr, authApi, $stateParams, $loading, $location, ProfessionalService, sessionService) {

        $scope.loading = true;
        this.$onInit = async function (){
            const { token, organizationId, recruiterId, isMarketplace } = $location.$$search;
            try {
                const newToken = await ProfessionalService.verify($stateParams.user_id, { token, organizationId, recruiterId: recruiterId ? recruiterId : undefined, isMarketplace: isMarketplace === 'true' });
                $scope.success = 'Your account successfully verified';
                $localStorage['token'] = newToken;
                sessionService.updateProfessional();
                sessionService.updateNotifications();
                $timeout(() => $state.go('splash'), 1000);
            } catch (e) {
                if(e.message.includes('Password is required.')){
                    $state.go('activate', {user_id: $stateParams.user_id, token, organization_id: organizationId, recruiter_id: recruiterId ? recruiterId : undefined, isMarketplace: isMarketplace === 'true' });
                }
                if (e instanceof Error && e.name === 'TokenExpiredError') {
                    $state.go('regenerateLink')
                }
                $scope.error = e.message;
            } finally {
                $scope.$apply();
            }
        }

    }]);